import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 bg-dark relative border-y border-white/5" data-id="element-73">
      <div className="container mx-auto px-4" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-6 bg-card p-6 md:p-8 rounded-3xl border border-white/10" data-id="element-75">
          <div className="shrink-0" data-id="element-76">
            <div className="w-24 h-24 rounded-full bg-accent-cyan/10 flex items-center justify-center border-2 border-accent-cyan/30" data-id="element-77">
              <ShieldCheck className="w-12 h-12 text-accent-cyan" data-id="element-78" />
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-79">
            <h2 className="text-3xl font-bold mb-3 text-white" data-id="element-80">
              GARANTÍA DE 7 DÍAS
            </h2>
            <p className="text-gray-300 text-lg" data-id="element-81">
              Si el kit no te sirve, te devolvemos el 100% de tu dinero. Sin
              preguntas, sin vueltas. Tu inversión está completamente asegurada.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}